module.exports = __webpack_public_path__ + "static/media/mm.39d2c078.svg";